import React from 'react';

import ProfileLoader from './ProfileLoader';
import ProfilePicture from './ProfilePicture';
import ProfileUserName from './ProfileUserName';
import ProfileUserBiography from './ProfileUserBiography';
import ProfileUserSkills from './ProfileUserSkills';
import ProfileUserExperiences from './ProfileUserExperiences';
import ProfileUserEducations from './ProfileUserEducations';
import ProfileUserCertifications from './ProfileUserCertifications';
import ProfileUserInterests from './ProfileUserInterests';

const Profile = ({ id }) => {
  return (
    <>
      <ProfileLoader userId={id} />
      <ProfilePicture />
      <ProfileUserName />
      <ProfileUserBiography />
      <ProfileUserSkills />
      <ProfileUserExperiences />
      <ProfileUserEducations />
      <ProfileUserCertifications />
      <ProfileUserInterests />
    </>
  );
};

export default Profile;
